import { object, string } from 'yup';

import { withForm } from 'components/FormWizard';
import { forgotPasswordAnswersSelector } from 'redux/forgotPassword/forgotPasswordSelectors';
import { ForgotPasswordOverview } from './ForgotPasswordOverview';
import { ForgotPasswordMtan } from './ForgotPasswordMtan';
import { ForgotPasswordSuccess } from './ForgotPasswordSuccess';

export const forgotPasswordStepNames = {
    emailField: 'emailField',
    mtan: 'mtan',
    success: 'success',
};

const emailSchema = (t) => object().shape({
    email: string().required(t('error.validation.cannot-be-empty'))
        .email(t('error.validation.email-not-valid')),
});

export const forgotPasswordSteps = (t) => [
    {
        title: '',
        renderContent: withForm({
            Component: ForgotPasswordOverview,
            schema: emailSchema(t),
            stepName: forgotPasswordStepNames.emailField,
            selector: forgotPasswordAnswersSelector,
            validations: null,
        }),
        hideStepBar: true,
    },
    {
        title: t('wizard.forgot-password.m-tan.header'),
        renderContent: (props) => <ForgotPasswordMtan {...props} />,
        hideStepBar: true,
    },
    {
        title: '',
        renderContent: withForm({
            Component: ForgotPasswordSuccess,
            schema: object().shape({}),
            stepName: forgotPasswordStepNames.success,
            selector: forgotPasswordAnswersSelector,
            validations: null,
        }),
        hideStepBar: true,
    },
];
